/*eslint-disable react/jsx-key */
import React, { Component } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  YAxis,
  XAxis,
  LabelList,
  Legend,
} from 'recharts';
import Icon from '../../../../components/Icon';
import Button from '../../../../components/Button';

import {
  ChartContainer,
  ChartTitle,
  LegendContainer,
  DataKeyContainer,
  IsPictureLabel,
  PictureStatusContainer,
  FooterContainer,
  ChartHeaderContainer,
  Container,
  Row,
  Col,
} from './styles';
import './styles.css';

const DischargeFilterEnum = {
  ALL: 1,
  NO_IMAGE: 2,
  WITH_IMAGE: 3,
};

export default class DischargeDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentDischargeFilter: DischargeFilterEnum.ALL,
    };
  }

  getDataKeyTransKey = dataKey => {
    switch (dataKey) {
      case 'totalDelivery':
        return 'Total';
      case 'parcialDelivery':
        return 'Parcial';
      case 'refusedDelivery':
        return 'Recusada';

      default:
        break;
    }
  };

  getPerPictureDataKeyTransKey = dataKey => {
    switch (dataKey) {
      case 'withPhoto':
        return {
          title: 'com foto',
          icon: 'with-image',
        };
      case 'withoutPhoto':
        return {
          title: 'sem foto',
          icon: 'no-image',
        };

      default:
        break;
    }
  };

  selectFilter = value => {
    this.setState({
      currentDischargeFilter: value,
    });
  };

  renderPercentageLabel = props => {
    const { x, y, width, fill, value } = props;

    return (
      <g>
        <text
          x={x + width / 2}
          fontSize={20}
          fontWeight="bold"
          position="top"
          y={y ? y - 28 : 250}
          fill={fill}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {value || 0}
        </text>
      </g>
    );
  };

  renderValueLabel = props => {
    const { x, y, width, fill, value } = props;

    return (
      <g>
        <text
          x={x + width / 2}
          fontSize={12}
          position="top"
          y={y ? y - 12 : 265}
          fill={fill}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {`${value || 0} CTEs`}
        </text>
      </g>
    );
  };

  renderCusomizedLegend = props => {
    const { payload } = props;

    return (
      <LegendContainer>
        {payload.map(entry => {
          const { dataKey, color } = entry;
          return (
            <DataKeyContainer backgroundColor={color}>
              {this.getDataKeyTransKey(dataKey)}
            </DataKeyContainer>
          );
        })}
      </LegendContainer>
    );
  };

  renderPerPictureCusomizedLegend = props => {
    const { payload } = props;
    return (
      <LegendContainer>
        {payload.map(entry => {
          const { dataKey, color } = entry;

          return (
            <PictureStatusContainer color={color}>
              <IsPictureLabel color={color}>
                {this.getPerPictureDataKeyTransKey(dataKey).title}
              </IsPictureLabel>
              <Icon name={this.getPerPictureDataKeyTransKey(dataKey).icon} />
            </PictureStatusContainer>
          );
        })}
      </LegendContainer>
    );
  };

  render() {
    const { data } = this.props;
    const { currentDischargeFilter } = this.state;

    const dischargeData = [
      {
        totalDischarges: data.totalDischarges,
        totalDelivery: data.totalDelivery,
        parcialDelivery: data.parcialDelivery,
        refusedDelivery: data.refusedDelivery,
        totalPercentage: `${
          data.totalDelivery
            ? ((data.totalDelivery / data.totalDischarges) * 100).toFixed(2)
            : 0
        } %`,
        parcialPercentage: `${
          data.parcialDelivery
            ? ((data.parcialDelivery / data.totalDischarges) * 100).toFixed(2)
            : 0
        } %`,
        refusedPercentage: `${
          data.refusedDelivery
            ? ((data.refusedDelivery / data.totalDischarges) * 100).toFixed(2)
            : 0
        } %`,

        withPhoto: Math.round((data.withPhoto * data.totalDischarges) / 100),
        withoutPhoto: Math.round(
          (data.withoutPhoto * data.totalDischarges) / 100,
        ),
        withPhotoPercentage: `${data.withPhoto ? data.withPhoto : 0} %`,
        withoutPhotoPercentage: `${
          data.withoutPhoto ? data.withoutPhoto : 0
        } %`,
      },
    ];

    const dischargeDataWithPhoto = [
      {
        totalDelivery: data.totalDeliveryWithPhoto,
        parcialDelivery: data.parcialDeliveryWithPhoto,
        refusedDelivery: data.refusedDeliveryWithPhoto,
        totalPercentage: `${
          data.totalDeliveryWithPhoto
            ? (
                (data.totalDeliveryWithPhoto / data.totalDischarges) *
                100
              ).toFixed(2)
            : 0
        } %`,
        parcialPercentage: `${
          data.parcialDeliveryWithPhoto
            ? (
                (data.parcialDeliveryWithPhoto / data.totalDischarges) *
                100
              ).toFixed(2)
            : 0
        } %`,
        refusedPercentage: `${
          data.refusedDeliveryWithPhoto
            ? (
                (data.refusedDeliveryWithPhoto / data.totalDischarges) *
                100
              ).toFixed(2)
            : 0
        } %`,
      },
    ];

    const dischargeDataWithoutPhoto = [
      {
        totalDelivery: data.totalDeliveryWithoutPhoto,
        parcialDelivery: data.parcialDeliveryWithoutPhoto,
        refusedDelivery: data.refusedDeliveryWithoutPhoto,
        totalPercentage: `${
          data.totalDeliveryWithoutPhoto
            ? (
                (data.totalDeliveryWithoutPhoto / data.totalDischarges) *
                100
              ).toFixed(2)
            : 0
        } %`,
        parcialPercentage: `${
          data.parcialDeliveryWithoutPhoto
            ? (
                (data.parcialDeliveryWithoutPhoto / data.totalDischarges) *
                100
              ).toFixed(2)
            : 0
        } %`,
        refusedPercentage: `${
          data.refusedDeliveryWithoutPhoto
            ? (
                (data.refusedDeliveryWithoutPhoto / data.totalDischarges) *
                100
              ).toFixed(2)
            : 0
        } %`,
      },
    ];

    const getChartData = () => {
      switch (currentDischargeFilter) {
        case DischargeFilterEnum.ALL:
          return dischargeData;

        case DischargeFilterEnum.NO_IMAGE:
          return dischargeDataWithoutPhoto;

        case DischargeFilterEnum.WITH_IMAGE:
          return dischargeDataWithPhoto;

        default:
          break;
      }
    };

    const allDischarges = data.totalDischarges;

    return (
        <Container>
          <Row>
            <Col md7>
              <ChartContainer>
                <ChartHeaderContainer>
                  <ChartTitle>Baixas</ChartTitle>
                  <div>
                    <Button
                      textLowerCase
                      text="todas"
                      icon="check"
                      skin={`${
                        currentDischargeFilter === DischargeFilterEnum.ALL
                          ? 'primary'
                          : 'gray-light'
                      }`}
                      small
                      onClick={() => this.selectFilter(DischargeFilterEnum.ALL)}
                    />
                    <Button
                      textLowerCase
                      text="sem foto"
                      icon="no-image"
                      skin={`${
                        currentDischargeFilter === DischargeFilterEnum.NO_IMAGE
                          ? 'primary'
                          : 'gray-light'
                      }`}
                      small
                      onClick={() =>
                        this.selectFilter(DischargeFilterEnum.NO_IMAGE)
                      }
                    />
                    <Button
                      textLowerCase
                      text="com foto"
                      icon="with-image"
                      skin={`${
                        currentDischargeFilter ===
                        DischargeFilterEnum.WITH_IMAGE
                          ? 'primary'
                          : 'gray-light'
                      }`}
                      small
                      onClick={() =>
                        this.selectFilter(DischargeFilterEnum.WITH_IMAGE)
                      }
                    />
                  </div>
                </ChartHeaderContainer>
                <div
                  style={{
                    width: '100%',
                    height: 350,
                  }}
                >
                  <div style={{ height: '100%', width: '100%' }}>
                    <ResponsiveContainer height="100%">
                      <BarChart
                        data={getChartData()}
                        barGap="12%"
                        margin={{
                          top: 50,
                          right: 50,
                          left: 50,
                          bottom: 0,
                        }}
                      >
                        <XAxis tickLine={false} />
                        <YAxis hide type="number" domain={[0, allDischarges]} />
                        <Legend content={this.renderCusomizedLegend} />
                        <Bar
                          dataKey="totalDelivery"
                          fill="#00AA00"
                          radius={[4, 4, 0, 0]}
                          barSize={64}
                        >
                          <LabelList
                            dataKey="totalPercentage"
                            fontSize={20}
                            fontWeight="bold"
                            position="top"
                            fill="#00AA00"
                            content={this.renderPercentageLabel}
                          />
                          <LabelList
                            dataKey="totalDelivery"
                            fontSize={12}
                            position="top"
                            fill="#828282"
                            content={this.renderValueLabel}
                          />
                        </Bar>
                        <Bar
                          dataKey="parcialDelivery"
                          fill="#FFAA00"
                          radius={[4, 4, 0, 0]}
                          barSize={64}
                        >
                          <LabelList
                            dataKey="parcialPercentage"
                            fontSize={20}
                            fontWeight="bold"
                            position="top"
                            fill="#FFAA00"
                            content={this.renderPercentageLabel}
                          />
                          <LabelList
                            dataKey="parcialDelivery"
                            fontSize={12}
                            position="top"
                            fill="#828282"
                            content={this.renderValueLabel}
                          />
                        </Bar>
                        <Bar
                          dataKey="refusedDelivery"
                          fill="#EE0020"
                          radius={[4, 4, 0, 0]}
                          barSize={64}
                        >
                          <LabelList
                            dataKey="refusedPercentage"
                            fontSize={20}
                            fontWeight="bold"
                            position="top"
                            fill="#EE0020"
                            content={this.renderPercentageLabel}
                          />
                          <LabelList
                            dataKey="refusedDelivery"
                            fontSize={12}
                            position="top"
                            fill="#828282"
                            content={this.renderValueLabel}
                          />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <FooterContainer>
                  <p>
                    <strong>Total de baixas: </strong>
                    {data.totalDischarges}
                  </p>
                </FooterContainer>
              </ChartContainer>
            </Col>
            <Col md5>
              <ChartContainer>
                <ChartTitle>Baixas com foto / sem foto</ChartTitle>
                <div
                  style={{
                    width: '100%',
                    height: 350,
                  }}
                >
                  <div style={{ height: '100%', width: '100%' }}>
                    <ResponsiveContainer height="100%">
                      <BarChart
                        data={dischargeData}
                        barGap="12%"
                        margin={{
                          top: 50,
                          right: 50,
                          left: 50,
                          bottom: 0,
                        }}
                      >
                        <XAxis tickLine={false} />
                        <YAxis hide type="number" domain={[0, allDischarges]} />
                        <Legend
                          content={this.renderPerPictureCusomizedLegend}
                        />
                        <Bar
                          dataKey="withPhoto"
                          fill="#263465"
                          radius={[4, 4, 0, 0]}
                          barSize={64}
                        >
                          <LabelList
                            dataKey="withPhotoPercentage"
                            fontSize={20}
                            fontWeight="bold"
                            position="top"
                            fill="#263465"
                            content={this.renderPercentageLabel}
                          />
                          <LabelList
                            dataKey="withPhoto"
                            fontSize={12}
                            position="top"
                            fill="#828282"
                            content={this.renderValueLabel}
                          />
                        </Bar>
                        <Bar
                          dataKey="withoutPhoto"
                          fill="#AAAAAA"
                          radius={[4, 4, 0, 0]}
                          barSize={64}
                        >
                          <LabelList
                            dataKey="withoutPhotoPercentage"
                            fontSize={20}
                            fontWeight="bold"
                            position="top"
                            fill="#AAAAAA"
                            content={this.renderPercentageLabel}
                          />
                          <LabelList
                            dataKey="withoutPhoto"
                            fontSize={12}
                            position="top"
                            fill="#828282"
                            content={this.renderValueLabel}
                          />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <FooterContainer>
                  <p>
                    <strong>Total de CTEs baixados: </strong>
                    {data.totalDischarges}
                  </p>
                </FooterContainer>
              </ChartContainer>
            </Col>
          </Row>
        </Container>
    );
  }
}
